import { render, staticRenderFns } from "./ReserveManage.vue?vue&type=template&id=22d55460"
import script from "./ReserveManage.vue?vue&type=script&lang=ts"
export * from "./ReserveManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports